import React, { useRef, useState } from 'react'
import "./ContactSection.css"
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const ContactSection = () => {
const [result, setResult] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", "c4a8f99b-88f4-4a65-80dd-a2147b3159f6");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();
    setResult(data.success ? "Success!" : "Error");
  };

    return (
        <section className="contact">

            {/* TOP CONTENT */}
            <div className="contact-top">

                <div className="contact-container">

                    {/* TITLE */}
                    <div className="contact-header">
                        <h2>
                            Our team is always ready <br />
                            <span>to support you!</span>
                        </h2>

                        <p>
                            Thank you for your interest in API. Please know that we read all the messages sent to us.
                            However, due to the large volume of messages we receive, you may not get a personal reply.
                            Please note, fields marked with an asterisk (*) are required to be filled out.
                        </p>
                    </div>

                    {/* CONTENT */}
                    <div className="contact-content">

                        {/* LEFT INFO */}
                        <div className="contact-info">

                            <div className="info-item">
                                <div className="icon">
                                    <FaMapMarkerAlt />
                                </div>
                                <div>
                                    <h4>Address</h4>
                                    <p>
                                        Factory: Abu Ghraib / Baghdad / Iraq .<br />
                                        Office: Al-Dawoody / Baghdad / Iraq .
                                    </p>
                                </div>
                            </div>

                            <div className="info-item">
                                <div className="icon">
                                    <FaPhoneAlt />
                                </div>
                                <div>
                                    <h4>Phone</h4>
                                    <p className="link">+964 770 708 08 08</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <div className="icon">
                                    <MdEmail />
                                </div>
                                <div>
                                    <h4>Email</h4>
                                    <p className="link">Info@api-irq.com</p>
                                </div>
                            </div>

                        </div>

                        {/* FORM (FLOATING) */}
                        <div className="contact-form">
                            <h3>Contact Form</h3>

                            <form  onSubmit={onSubmit}>

                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Name"
                                    required
                                />

                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    required
                                />

                                <textarea
                                    name="message"
                                    placeholder="Message"
                                    required
                                />

                                <button type="submit">
                                    Submit
                                </button>

                                 <p>{result}</p>

                            </form>
                        </div>

                    </div>

                </div>

            </div>

            {/* MAP */}
            <div className="contact-map">
                <iframe
                    src="https://maps.google.com/maps?q=baghdad&t=&z=13&ie=UTF8&iwloc=&output=embed"
                    frameBorder="0"
                    allowFullScreen
                    title="map"
                ></iframe>
            </div>

        </section>
    )
}

export default ContactSection